/* eslint-disable @typescript-eslint/typedef */
import { StoreState } from './StoreState';

export const storeSelector = (state: StoreState): StoreState => state;
